import { Api } from './../game/index';

export default class State {

    constructor(GAME, debug = false) {
        this.debug = window.location.hash === '#debug';
        this.GAME = GAME;
        this.API = new Api();
        this.loaded = false;
        this.loadState();
    }


    getRandomBetween(min, max) {
        return Math.random() * (max - min) + min;
    }

    getRandomLevel() {
        console.log('creating random level');

        return {
            level: 1,
            wind: {
                direction: 'r',
                intensity: {
                    min: this.getRandomBetween(0, 0.8),
                    max: this.getRandomBetween(0, 0.8)
                }
            },
            rain: {
                intensity: null
            },
            position: {
                x: this.getRandomBetween(0, 52),
                y: 0.29,
                z: this.getRandomBetween(20, 80)
            },
            time_limit: this.getRandomBetween(6000, 10000),
            checkpoint: false,
            coins: null
        };
    }

    getName() {
        return this.name || '';;
    }

    setName(name) {
        this.name = name;
        this.updateNameElement();
    }

    getGender() {
        return this.gender ;
    }

    setGender(gender) {
        this.gender = gender;
    }

    getTeam() {
        return this.team || 'Auckland';
    }

    setTeam(team) {
        this.team = team;
        this.updateTeamElement();
    }

    getCheckpoint() {
        return parseInt(this.checkpoint);
    }

    getLevel() {
        return this.level;
    }

    setLevel(level) {
        this.level = level;
        this.updateLevelElement();
    }

    getScore() {
        return parseInt(this.score);
    }

    setScore(score) {
        this.score = parseInt(score);
        this.updateScoreElement();
    }

    updateNameElement() {
        document.querySelector('.js-name-element').innerHTML = this.getName();
    }

    updateAvatarElement(avatar) {
        document.querySelector('.js-avatar-element').src = avatar || `_resources/themes/mercury/dist/images/standard/${this.getTeam()}_${this.getGender()}_avatar.png`;
    }

    updateTeamElement(team) {
        document.querySelector('.js-team-element').innerHTML = team || this.getTeam();
    }

    updateDivisionElement(team) {
        document.querySelector('.js-division-element').innerHTML = team || this.getTeam();
    }

    updatePredictedTeamElement(team) {
        document.querySelector('.js-predicted-team-element').innerHTML = team || this.getTeam();
    }

    updateLevelElement(level) {
        document.querySelector('.js-current-level').innerHTML = level || this.getLevel();
    }

    updateScoreElement(score) {
        document.querySelector('.js-score').innerHTML = score || this.getScore();
    }

    startKickGame() {
        console.log('Starting kick game with:')
        return this.API.post('/start_kick_game', {
            gender: this.getGender(),
            nickname: this.getName(),
            team: this.getTeam(),
        })
    }

    updateState(data) {
        this.level = (data.data.current_kick_level_number) ? data.data.current_kick_level_number : 1;
        this.score = parseInt(data.data.total_kick_points);
        this.checkpoint = parseInt(data.data.checkpoint);
        this.name = data.data.nickname || data.data.name;
        this.team = data.data.team;
        this.gender = data.data.gender;
        this.data = data.data;

    }



    loadState() {

        this.API.get('/get_state').then(data => {

            console.log('Loading state:', data);


            // No data lets start a new game
            if (data.code === 202) {
                this.level = 0;
                this.score = 0;
                this.checkpoint = 0;
                this.name = '';
                this.gender = '';
                this.nickname = '';
                this.team = '';
            }

            // Load the state from the API
            else if (data.code === 200) {
                this.level = (data.data.current_kick_level_number) ? data.data.current_kick_level_number : 1;
                this.score = parseInt(data.data.total_kick_points);
                this.checkpoint = parseInt(data.data.checkpoint);
                this.name = data.data.nickname || data.data.name;
                this.gender = data.data.gender;
                this.team = data.data.team;
                this.data = data.data;
            }



            // Bad bad not good
            else {
                console.error('Error loading state:', data.message);
            }

            if (!this.loaded) {
                this.GAME.setDebug();
            }

            this.loaded = true;


            console.log(`%c Level: ${this.getLevel()} Score: ${this.getScore()}`, "color:#fff;font-size:12px; padding:0.45rem 0.75rem; margin: 0rem auto 1rem auto; font-family: Helvetica, sans-serif; border: 2px solid #0dd8d8; border-radius: 4px;font-weight: 100;background-size: cover;background-repeat: no-repeat;border: double 1px transparent;background-image: linear-gradient(#282828, #282828), radial-gradient(circle at top left, #2563EB, #82a0e2);background-origin: border-box;background-clip: padding-box, border-box;")

        })

    }

    async fetchState() {
        return await this.API.get('/get_state');
    }

    hydrate(data) {
        this.level = (data.data.current_kick_level_number) ? data.data.current_kick_level_number : 1;
        this.score = parseInt(data.data.total_kick_points);
        this.checkpoint = parseInt(data.data.checkpoint);
        this.name = data.data.nickname || data.data.name;
        this.team = data.data.team;
        this.gender = data.data.gender;
        this.data = data.data;
    }

    getState() {
        return {
            level: parseInt(this.level),
            checkpoint: parseInt(this.checkpoint),
            score: parseInt(this.score),
            name: this.name,
            team: this.team
        };
    }

    clearState() {
        this.loadState();
    }

}